import { cn } from "@eisox/design-system";
import { Link, type LinkProps } from "@tanstack/react-router";

export const DisableLink: React.FC<LinkProps & { className?: string; disabled?: boolean }> = ({
  disabled,
  className,
  ...props
}) => (
  <Link
    {...props}
    className={cn(disabled && "cursor-default text-primary-dark-gray", className)}
    onClick={disabled ? e => e.preventDefault() : undefined}
  />
);
